import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import TopNav from "./components/TopNav";
import DynamicNav from "./components/DynamicNav";
import CommandPalette from "./components/CommandPalette";
import Breadcrumbs from "./components/Breadcrumbs";
import useMenus from "./hooks/useMenus";

import { ThemeProvider } from "./context/ThemeContext";
// NOTE: removed `import { menus } from "./menuData";` to avoid name collision

import RequirePerm from "./guards/RequirePerm";
import RequireMaster from "./guards/RequireMaster";

import Dashboard from "./pages/Dashboard";
import UsersList from "./pages/UsersList";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import CreateUser from "./pages/CreateUser";
import WareHouseList from "./pages/WarehouseList";
import ViewOnewarehouse from "./pages/ViewOnewarehouse";
import CategoryList from "./pages/CategoryList";
import UnitManager from "./pages/UnitList";
import ProductListCompact from "./pages/ProductList";
import AddProduct from "./pages/AddProduct";
import EditAddProduct from "./pages/EditProduct";
import ProductionSteps from "./pages/ProductionSteps";
// import ProductionProcess from "./pages/CreateProductionSteps";
import CreateDepartment from "./pages/CreateDepartment";
import CustomerGroupList from "./pages/CustomerGroupList";
import CreateCustomerGroup from "./pages/CreateCustomerGroup";
import AccountCategoryPage from "./pages/AccountCategory";
import RoleList from "./pages/RoleList";
import CreateHeriarchy from "./pages/ViewHeirarchy";
import AddRoleNew from "./pages/AddRoleNew";
import DepartmentRoleAssign from "./pages/DepartmentRoleAssign";
import EditTeamRolePosition from "./pages/EditTeamRolePosition";
import SalesPersonPincodes from "./pages/AssignPincode";
import UserListMaster from "./pages/master/UserListMaster";
import SuperAdminListPlain from "./pages/master/SuperAdminList";
import ViewSuperAdmin from "./pages/master/ViewSuperadmin";
import EditSuperAdmin from "./pages/master/EditSuperAdmin";
import CreateSuperAdmin from "./pages/master/CreateSuperadmin";
import RoleListMaster from "./pages/master/RoleListMaster";
import AddRoleMaster from "./pages/master/AddRoleMaster";
import UpdateRole from "./pages/master/EditRole";
import RolePermissionView from "./pages/RoleView";
import GroupList from "./pages/master/GroupList";
import GroupCreate from "./pages/master/CreateGroup";
import GroupEdit from "./pages/master/GroupEdit";
import SubscriptionPlanList from "./pages/master/SubscriptionPlans";
import Addplan from "./pages/master/AddPlan";
import LocationPin from "./pages/master/LocationPin";
import TransporterListCompact from "./pages/TransporterList";
import TransporterCreate from "./pages/CreateTransporter";
import TransporterEdit from "./pages/EditTransporter";
import TransporterView from "./pages/ViewTransporter";
import CustomerListCompact from "./pages/CustomerList";
import CreateCustomerCompact from "./pages/CreateCustomer";
import AssignTeamMember from "./pages/AssignTeamMember";
import SalesInvoiceList from "./pages/SalesInvoiceList";
import CreateInvoice from "./pages/CreateInvoice";
import AddOtherChargesList from "./pages/ChargesList";
import CompleteOrder from "./pages/CompleteOrder";
import HouseProductList from "./pages/PriceList";
import OrderList from "./pages/OrderList";
import CreateOrder from "./pages/CreateOrder";
import EditOrder from "./pages/EditOrder";
import CancelOrder from "./pages/CancelOrder";
import SalesLead from "./pages/SalesLead";
import ReceiptList from "./pages/ReceiptsList";
import CreateReceipt from "./pages/CreateReceipt";
import PaymentList from "./pages/PaymentList";
import CreatePayment from "./pages/CreatePayment";
import CashBookReports from "./pages/CashBook";
import PartyLedgersView from "./pages/Ledger";
import PurchaseOrderViewList from "./pages/PurchaseOrderList";
import AddPurchaseOrder from "./pages/CreatePurchaseOrder.js";
import PendingPurchase from "./pages/PendingPurchase.js";
import PurchaseReturn from "./pages/PurchaseReturn.js";
import PurchaseInvoice from "./pages/PurchaseInvoice.js";
import HeadtargetingList from "./pages/TargetList.js";
import CreateTarget from "./pages/CreateTarget.js";
import CustomerTarget from "./pages/CustomerTarget.js";
import CreateCustomerTarget from "./pages/CreateCustomerTarget.js";
import SalesPersonTargetList from "./pages/SalesPersonTargetList.js";
import TargetAchieved from "./pages/TargetAchieved.js";
import EditCustomerTarget from "./pages/EditCustomerTarget.js";
import CreatePromotionalActivity from "./pages/CreatePromotionalActivity.js";
import GSTR1 from "./pages/GSTR1.js";
import GSTR3B1 from "./pages/GSTR3B.js";
import GSTR2B_B2B from "./pages/GSTR2B.js";
import ProductWisePurchaseReport from "./pages/ProductWisePurchaseReport.js";
import PurchaseOrderReport from "./pages/PurchaseOrderReport.js";
import HSNWiseReport from "./pages/HSNReport.js";
import PurchaseReportAmount from "./pages/PurchaseReportAmount.js";
import StockTransfer from "./pages/InwardStock.js";
import OutwardStock from "./pages/OutwardStock.js";
import LowStockAlert from "./pages/LowStockAlert.js";
import DamagedStock from "./pages/DamagedStock.js";
import CreateDamagedStock from "./pages/CreateDamagedStock.js";
import OverDueStock from "./pages/OverdueStock.js";
import DeadPartyReport from "./pages/DeadPartyReport.js";
import StockDifferenceReport from "./pages/StockDifference.js";
import WareHouseOverDueStock from "./pages/WareHouseOverDueStock.js";
import ClosingStockReport from "./pages/ClosingStock.js";
import Salesreport from "./pages/SalesReport.js";
import SalesOrderReport from "./pages/SalesOrderReport.js";
import TargetReport from "./pages/TargetReport.js";
import TaxReport from "./pages/TaxReport.js";
import LockPartyReport from "./pages/LockPartyReport.js";
import BankStatementReport from "./pages/BankStatement.js";
import ProfitandLossReport from "./pages/ProfitAndLossReport.js";
import PromotionalActivityReport from "./pages/PromotionalActivityReport.js";
import ItemProductList from "./pages/ItemProductList.js";
import StartProductionProcess from "./pages/StartProductionProcess.js";
import RawProductList from "./pages/RawProduct.js";
import AddRawProduct from "./pages/CreateRawProduct.js";
import EditRawProduct from "./pages/EditRawProduct.js";
import StartProduction from "./pages/StartProduction.js";
import WarehouseStockTransfer from "./pages/StockTransfer.js";
import CreateStockTransfer from "./pages/CreateStockTransfer.js";
import CreatePurchaseInvoice from "./pages/CreatePurchaseInvoice.js";
import ProductionProductSection from "./pages/ProductionProductSection.js";
import EditOrderInvoice from "./pages/EditOrderInvoice.js";
import PromotionalActivityList from "./pages/PromotionalActivityList.js";
import CreditNoteList from "./pages/CreditNote.js";
import DebitNoteList from "./pages/DebitNote.js";
import DamageStockReport from "./pages/DamageStockReport.js";
import Wastageproduction from "./pages/Wastageproduction.js";
import ExpenseAccountsList from "./pages/ExpenseAccountList.js";
import InvoiceTemplateSettings from "./pages/SettingTab.js";
import CreateSalesOrderInvoice from "./pages/CreateSalesOrderInvoice.js";
import CreateChallan from "./pages/CreateChallan.js";
import TargetTabs from "./pages/TargetTabs.js";
import UserProfile from "./pages/UserProfile.js";
import EditPurchaseOrder from "./pages/EditPurchaseOrder.js";
import PurchaseTabs from "./pages/PurchaseTabs.js";
import ActivityLog from "./pages/master/ActivityLog.js";
import DeviceRegistry from "./pages/DeviceRegistry.js";
import CreateSalesPersonTarget from "./pages/CreateSalesPersonTarget.js";
import EditSalesPersonTarget from "./pages/EditSalesPersonTarget.js";
import CreateUserAccount from "./pages/CreateUserAccount.js";
import TransactionsTabs from "./pages/TransactionsTabs.js";
// import GstInputReport from "../../dms16jan/src/views/apps/freshlist/customer/Ticketing/GstInputReport.js";
import GSTInputOutputReports from "./pages/GSTInputOutputReports.js";
import StockReports from "./pages/StockReport.js";
import AssignmentFlow from "./pages/AssignmentFlow.js";
import GSMCalculator from "./pages/GSMCalculator.js";
import GSTReportFlow from "./pages/GSTReportFlow.js";
import PurchaseReportFlow from "./pages/PurchaseReportFlow.js";
import SaleReportFlow from "./pages/SaleReportFlow.js";
import FinanceReportFlow from "./pages/FinanceReportFlow.js";
import BooksOfAccountFlow from "./pages/BooksOfAccountFlow.js";
import PartyLedgerSummaryAll from "./pages/AllLedger.js";
import CustomerTargetEditPage from "./pages/CustomerTargetEditPage.js";
import EditPurchaseInvoice from "./pages/EditPurchaseInvoice.js";
import PartyTransactionDetails from "./pages/PartyTransactionDetails.js";
import PaymentVerification from "./pages/PaymentVerification.js";

/** Route guard: only lets users in if token + userData are present */
function RequireAuth({ children }) {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  const userData =
    localStorage.getItem("userData") || sessionStorage.getItem("userData");
  const location = useLocation();

  if (!token || !userData) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

export default function App() {
  const navMenus = useMenus(); // renamed to avoid any collisions
  const location = useLocation();
  const isLogin = location.pathname.startsWith("/login");

  const [quickItems, setQuickItems] = useState(() => {
    try {
      const saved = localStorage.getItem("quickItems");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("quickItems", JSON.stringify(quickItems));
  }, [quickItems]);

  return (
    <ThemeProvider>
      <div className="app-shell">
        {/* Hide both headers and breadcrumbs on the login page */}
        {!isLogin && (
          <>
            <TopNav
              menus={navMenus}
              onOpenPalette={() => setPaletteOpen(true)}
            />
            {/* <DynamicNav
              allMenus={navMenus}
              quickItems={quickItems}
              setQuickItems={setQuickItems}
            /> */}
          </>
        )}

        <main className="page-content">
          <Routes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />
            {/* Protected routes */}
            <Route
              path="/app/master/users"
              element={
                <RequireMaster>
                  <UserListMaster />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/superadmins"
              element={
                <RequireMaster>
                  <SuperAdminListPlain />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/superadmins/create/:id"
              element={
                <RequireMaster>
                  <CreateSuperAdmin />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/superadmins/:id"
              element={
                <RequireMaster>
                  <ViewSuperAdmin />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/superadmins/edit/:id"
              element={
                <RequireMaster>
                  <EditSuperAdmin />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/roles"
              element={
                <RequireMaster>
                  <RoleListMaster />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/roles/create"
              element={
                <RequireMaster>
                  <AddRoleMaster />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/roles/edit/:id"
              element={
                <RequireMaster>
                  <UpdateRole />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/groups"
              element={
                <RequireMaster>
                  <GroupList />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/groups/create"
              element={
                <RequireMaster>
                  <GroupCreate />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/groups/edit/:id"
              element={
                <RequireMaster>
                  <GroupEdit />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/subscription-plans"
              element={
                <RequireMaster>
                  <SubscriptionPlanList />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/subscription-plans/create/:id"
              element={
                <RequireMaster>
                  <Addplan />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/location-pins"
              element={
                <RequireMaster>
                  <LocationPin />
                </RequireMaster>
              }
            />
            <Route
              path="/app/master/activity-logs"
              element={
                <RequireMaster>
                  <ActivityLog />
                </RequireMaster>
              }
            />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/app/users"
              element={
                <RequirePerm page="Create User" action="View">
                  <UsersList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/users/create/:id"
              element={
                <RequirePerm page="Create User" action="Create">
                  <CreateUser />
                </RequirePerm>
              }
            />
            <Route
              path="/app/assign-team-member"
              element={
                <RequirePerm page="Assign Team" action="Create">
                  <AssignTeamMember />
                </RequirePerm>
              }
            />
            <Route
              path="/app/warehouses"
              element={
                <RequirePerm page="Warehouse" action="View">
                  <WareHouseList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/warehouses/viewonewarehouse/:id"
              element={
                <RequirePerm page="Warehouse" action="View">
                  <ViewOnewarehouse />
                </RequirePerm>
              }
            />
            <Route
              path="/app/categories"
              element={
                <RequirePerm page="Category List" action="View">
                  <CategoryList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/units"
              element={
                <RequireAuth>
                  <UnitManager />
                </RequireAuth>
              }
            />
            <Route
              path="/app/products"
              element={
                <RequirePerm page="Product Creation" action="View">
                  <ProductListCompact />
                </RequirePerm>
              }
            />
            <Route
              path="/app/products/create"
              element={
                <RequirePerm page="Product Creation" action="Create">
                  <AddProduct />
                </RequirePerm>
              }
            />
            <Route
              path="/app/products/edit/:id"
              element={
                <RequirePerm page="Product Creation" action="Edit">
                  <EditAddProduct />
                </RequirePerm>
              }
            />
            <Route
              path="/app/production-steps"
              element={
                <RequireAuth>
                  <ProductionSteps />
                </RequireAuth>
              }
            />
            {/* <Route
              path="/app/production-steps/create"
              element={
                <RequireAuth>
                  <ProductionProcess />
                </RequireAuth>
              }
            /> */}
            <Route
              path="/app/departments"
              element={
                <RequireAuth>
                  <CreateDepartment />
                </RequireAuth>
              }
            />
            <Route
              path="/app/grades"
              element={
                <RequirePerm page="Create Grade" action="View">
                  <CustomerGroupList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/grades/create/:id"
              element={
                <RequirePerm page="Create Grade" action="Create">
                  <CreateCustomerGroup />
                </RequirePerm>
              }
            />
            <Route
              path="/app/accounts"
              element={
                <RequireAuth>
                  <AccountCategoryPage />
                </RequireAuth>
              }
            />
            <Route
              path="/app/roles"
              element={
                <RequireAuth>
                  <RoleList />
                </RequireAuth>
              }
            />
            <Route
              path="/app/view-heirarchy"
              element={
                <RequireAuth>
                  <CreateHeriarchy />
                </RequireAuth>
              }
            />
            <Route
              path="/app/roles/view/:id"
              element={
                <RequireAuth>
                  <RolePermissionView />
                </RequireAuth>
              }
            />
            <Route
              path="/app/roles/create"
              element={
                <RequireAuth>
                  <AddRoleNew />
                </RequireAuth>
              }
            />
            <Route
              path="/app/role-assign-department"
              element={
                <RequireAuth>
                  <DepartmentRoleAssign />
                </RequireAuth>
              }
            />
            <Route
              path="/app/edit-team-role-position"
              element={
                <RequireAuth>
                  <EditTeamRolePosition />
                </RequireAuth>
              }
            />
            <Route
              path="/app/assign-pincode"
              element={
                <RequireAuth>
                  <SalesPersonPincodes />
                </RequireAuth>
              }
            />
            <Route
              path="/app/transporters"
              element={
                <RequirePerm page="Create Transporter" action="View">
                  <TransporterListCompact />
                </RequirePerm>
              }
            />
            <Route
              path="/app/transporters/create/:id"
              element={
                <RequirePerm page="Create Transporter" action="Create">
                  <TransporterCreate />
                </RequirePerm>
              }
            />
            <Route
              path="/app/transporters/edit/:id"
              element={
                <RequirePerm page="Create Transporter" action="Edit">
                  <TransporterEdit />
                </RequirePerm>
              }
            />
            <Route
              path="/app/transporters/view/:id"
              element={
                <RequirePerm page="Create Transporter" action="View">
                  <TransporterView />
                </RequirePerm>
              }
            />
            <Route
              path="/app/customers"
              element={
                <RequirePerm page="Create Customer" action="View">
                  <CustomerListCompact />
                </RequirePerm>
              }
            />
            <Route
              path="/app/customers/create/:id"
              element={
                <RequirePerm page="Create Customer" action="Create">
                  <CreateCustomerCompact />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-invoices"
              element={
                <RequirePerm page="Sales Invoice" action="View">
                  <SalesInvoiceList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-invoices/create"
              element={
                <RequirePerm page="Sales Invoice" action="Create">
                  <CreateInvoice />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-invoices/edit/:id"
              element={
                <RequirePerm page="Sales Invoice" action="Edit">
                  <EditOrderInvoice />
                </RequirePerm>
              }
            />
            <Route
              path="/app/complete-orders"
              element={
                <RequirePerm page="Complete Order" action="View">
                  <CompleteOrder />
                </RequirePerm>
              }
            />
            <Route
              path="/app/price-list"
              element={
                <RequirePerm page="Price List" action="View">
                  <HouseProductList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/charges"
              element={
                <RequirePerm page="Add Charges" action="View">
                  <AddOtherChargesList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-orders"
              element={
                <RequirePerm page="Sales Order" action="View">
                  <OrderList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-orders/create"
              element={
                <RequirePerm page="Sales Order" action="Create">
                  <CreateOrder />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-orders/edit/:id"
              element={
                <RequirePerm page="Sales Order" action="Edit">
                  <EditOrder />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-flow"
              element={
                <RequirePerm page="Cancelled Order" action="View">
                  <CancelOrder />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-leads"
              element={
                <RequirePerm page="Sales Lead" action="View">
                  <SalesLead />
                </RequirePerm>
              }
            />
            <Route
              path="/app/receipts"
              element={
                <RequirePerm page="Receipt" action="View">
                  <TransactionsTabs />
                </RequirePerm>
              }
            />
            <Route
              path="/app/books-of-account-flow"
              element={
                <RequirePerm page="Receipt" action="View">
                  <BooksOfAccountFlow />
                </RequirePerm>
              }
            />
            <Route
              path="/app/receipts/create/:id"
              element={
                <RequirePerm page="Receipt" action="Create">
                  <CreateReceipt />
                </RequirePerm>
              }
            />
            <Route
              path="/app/PartyTransactionDetails"
              element={
                <RequirePerm page="Receipt" action="Create">
                  <PartyTransactionDetails />
                </RequirePerm>
              }
            />
            <Route
              path="/app/PaymentVerification"
              element={
                <RequirePerm page="Receipt" action="Create">
                  <PaymentVerification />
                </RequirePerm>
              }
            />
            <Route
              path="/app/payments"
              element={
                <RequirePerm page="Payment" action="View">
                  <PaymentList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/payments/create/:id"
              element={
                <RequirePerm page="Payment" action="Create">
                  <CreatePayment />
                </RequirePerm>
              }
            />
            <Route
              path="/app/cashbook"
              element={
                <RequirePerm page="Cashbook" action="View">
                  <CashBookReports />
                </RequirePerm>
              }
            />
            <Route
              path="/app/ledger"
              element={
                <RequirePerm page="Party Ledger" action="View">
                  <PartyLedgersView />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-orders"
              element={
                <RequirePerm page="Purchase Order" action="View">
                  <PurchaseOrderViewList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-orders/edit/:id"
              element={
                <RequirePerm page="Purchase Order" action="Edit">
                  <EditPurchaseOrder />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-invoice/edit/:id"
              element={
                <RequirePerm page="Purchase Order" action="Edit">
                  <EditPurchaseInvoice />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-orders/create"
              element={
                <RequirePerm page="Purchase Order" action="Create">
                  <AddPurchaseOrder />
                </RequirePerm>
              }
            />
            <Route
              path="/app/pending-purchase"
              element={
                <RequirePerm page="Purchase Pending" action="View">
                  <PendingPurchase />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-return"
              element={
                <RequirePerm page="Purchase Return" action="View">
                  <PurchaseReturn />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-reports"
              element={
                <RequirePerm page="Purchase Return" action="View">
                  <PurchaseReportFlow />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-invoice"
              element={
                <RequirePerm page="Purchase Invoice" action="View">
                  <PurchaseInvoice />
                </RequirePerm>
              }
            />
            <Route
              path="/app/list-of-accounts"
              element={
                <RequirePerm page="Purchase Invoice" action="View">
                  <PartyLedgerSummaryAll />
                </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-invoice/create"
              element={
                <RequirePerm page="Purchase Invoice" action="Create">
                  <CreatePurchaseInvoice />
                </RequirePerm>
              }
            />
            <Route
              path="/app/targets"
              element={
                <RequirePerm page="Target Creation" action="View">
                  <HeadtargetingList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/targets/create"
              element={
                <RequirePerm page="Target Creation" action="Create">
                  <CreateTarget />
                </RequirePerm>
              }
            />
            <Route
              path="/app/customer-targets"
              element={
                <RequirePerm page="Customer Target Creation" action="View">
                  <CustomerTarget />
                </RequirePerm>
              }
            />
            <Route
              path="/app/customer-targets/create/:id"
              element={
                <RequirePerm page="Customer Target Creation" action="Create">
                  <CreateCustomerTarget />
                </RequirePerm>
              }
            />
            <Route
              path="/app/customer-targets/edit/:id"
              element={
                <RequirePerm page="Customer Target Creation" action="Edit">
                  <EditCustomerTarget />
                </RequirePerm>
              }
            />
            <Route
              path="/app/salesperson-targets"
              element={
                <RequirePerm page="Salesperson Target" action="Create">
                  <SalesPersonTargetList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/target-achieved"
              element={
                <RequirePerm page="Target Achieved" action="View">
                  <TargetAchieved />
                </RequirePerm>
              }
            />
            <Route
              path="/app/promotional-activity"
              element={
                <RequirePerm page="Promotional Activity" action="View">
                  <CreatePromotionalActivity />
                </RequirePerm>
              }
            />
            <Route
              path="/app/promotional-activity/list"
              element={
                <RequirePerm page="Promotional Activity" action="View">
                  <PromotionalActivityList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/gstr1"
              element={
                <RequirePerm page="GSTR 1" action="View">
                  <GSTR1 />
                </RequirePerm>
              }
            />
            <Route
              path="/app/gstr3b"
              element={
                <RequirePerm page="GSTR 3B" action="View">
                  <GSTR3B1 />
                </RequirePerm>
              }
            />
            <Route
              path="/app/gstr2b"
              element={
                <RequirePerm page="GSTR 2B" action="View">
                  <GSTR2B_B2B />
                </RequirePerm>
              }
            />
            <Route
              path="/app/hsn-wise-report"
              element={
                <RequirePerm page="HSN WISE REPORT" action="View">
                  <HSNWiseReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/gst-reports"
              element={
                <RequirePerm page="HSN WISE REPORT" action="View">
                  <GSTReportFlow />
                </RequirePerm>
              }
            />
            {/* GSTReportFlow */}
            <Route
              path="/app/purchase-report-amount"
              element={
                <RequirePerm
                  page="PARTY WISE AND PRODUCT WISE PURCHASE REPORT"
                  action="View"
                >
                  <PurchaseReportAmount />
                </RequirePerm>
              }
            />
            <Route
              path="/app/product-wise-purchase-report"
              element={
                <RequirePerm page="PRODUCT WISE PURCHASE REPORT" action="View">
                  <ProductWisePurchaseReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/product-order-report"
              element={
                <RequirePerm page="PURCHASE ORDER REPORT" action="View">
                  <PurchaseOrderReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/inward-stock"
              element={
                <RequirePerm page="Inward Stock" action="View">
                  <StockTransfer />
                </RequirePerm>
              }
            />
            <Route
              path="/app/outward-stock"
              element={
                <RequirePerm page="Outward Stock" action="View">
                  <OutwardStock />
                </RequirePerm>
              }
            />
            <Route
              path="/app/low-stock"
              element={
                <RequirePerm page="Low Stock" action="View">
                  <LowStockAlert />
                </RequirePerm>
              }
            />
            <Route
              path="/app/damaged-stock"
              element={
                <RequirePerm page="Damaged Stock" action="View">
                  <DamagedStock />
                </RequirePerm>
              }
            />
            <Route
              path="/app/damaged-stock/create"
              element={
                <RequirePerm page="Damaged Stock" action="Create">
                  <CreateDamagedStock />
                </RequirePerm>
              }
            />
            <Route
              path="/app/overdue-stock"
              element={
                <RequirePerm page="OverDue Stock" action="View">
                  <OverDueStock />
                </RequirePerm>
              }
            />
            <Route
              path="/app/dead-party"
              element={
                <RequirePerm page="Dead Party" action="View">
                  <DeadPartyReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/stock-diff"
              element={
                <RequirePerm page="STOCK DIFFERENCE REPORT" action="View">
                  <StockDifferenceReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/dead-stock"
              element={
                <RequirePerm page="Dead Stock Report" action="View">
                  <WareHouseOverDueStock />
                </RequirePerm>
              }
            />
            <Route
              path="/app/closing-stock"
              element={
                <RequirePerm page="Closing Stock Report" action="View">
                  <ClosingStockReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-report"
              element={
                <RequirePerm
                  page="PARTY WISE AND PRODUCT WISE SALE REPORT"
                  action="View"
                >
                  <Salesreport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-reports"
              element={
                <RequirePerm
                  page="PARTY WISE AND PRODUCT WISE SALE REPORT"
                  action="View"
                >
                  <SaleReportFlow />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-order-report"
              element={
                <RequirePerm page="Sales Order Report" action="View">
                  <SalesOrderReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/target-report"
              element={
                <RequirePerm page="SalesTarget Report" action="View">
                  <TargetReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/tax-report"
              element={
                <RequirePerm page="TAX REPORT" action="View">
                  <TaxReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/lock-party-report"
              element={
                <RequirePerm page="Lock Party Report" action="View">
                  <LockPartyReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/bank-statement-report"
              element={
                <RequirePerm page="Bank Statement" action="View">
                  <BankStatementReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/profit-loss-report"
              element={
                <RequirePerm page="Profit and Loss Report" action="View">
                  <ProfitandLossReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/promotional-activity-report"
              element={
                <RequirePerm page="Promotional Activity Report" action="View">
                  <PromotionalActivityReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/finance-reports"
              element={
                <RequirePerm page="Promotional Activity Report" action="View">
                  <FinanceReportFlow />
                </RequirePerm>
              }
            />

            <Route
              path="/app/production-items"
              element={
                <RequirePerm page="Items" action="View">
                  <ItemProductList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/production-process/create"
              element={
                <RequirePerm page="Production Process" action="Create">
                  <StartProductionProcess />
                </RequirePerm>
              }
            />
            <Route
              path="/app/raw-product"
              element={
                <RequirePerm page="Raw Products" action="View">
                  <RawProductList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/raw-product/create"
              element={
                <RequirePerm page="Raw Products" action="Create">
                  <AddRawProduct />
                </RequirePerm>
              }
            />
            <Route
              path="/app/raw-product/edit/:id"
              element={
                <RequirePerm page="Raw Products" action="Edit">
                  <EditRawProduct />
                </RequirePerm>
              }
            />
            <Route
              path="/app/production-product-section"
              element={
                <RequirePerm page="Raw Products" action="View">
                  <ProductionProductSection />
                </RequirePerm>
              }
            />
            <Route
              path="/app/start-production"
              element={
                <RequirePerm page="Start Production" action="Create">
                  <StartProduction />
                </RequirePerm>
              }
            />
            <Route
              path="/app/stock-transfer"
              element={
                <RequirePerm page="Stock Transfer" action="View">
                  <WarehouseStockTransfer />
                </RequirePerm>
              }
            />
            <Route
              path="/app/stock-transfer/create"
              element={
                <RequirePerm page="Stock Transfer" action="Create">
                  <CreateStockTransfer />
                </RequirePerm>
              }
            />
            <Route
              path="/app/sales-order-report"
              element={
                <RequirePerm page="Sales Order Report" action="View">
                  <SalesOrderReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/credit-note"
              element={
                <RequirePerm page="CreditNote" action="View">
                  <CreditNoteList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/debit-note"
              element={
                <RequirePerm page="Debit Notes" action="View">
                  <DebitNoteList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/damaged-stock-report"
              element={
                <RequirePerm page="Damage Report" action="View">
                  <DamageStockReport />
                </RequirePerm>
              }
            />
            <Route
              path="/app/wastage-report"
              element={
                <RequirePerm page="Wastage Detail" action="View">
                  <Wastageproduction />
                </RequirePerm>
              }
            />
            <Route
              path="/app/expense-account"
              element={
                <RequirePerm page="Expense Accounts" action="View">
                  <ExpenseAccountsList />
                </RequirePerm>
              }
            />
            <Route
              path="/app/invoice-template"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <InvoiceTemplateSettings />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/invoice-sales-order/:id"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <CreateSalesOrderInvoice />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/challans/create"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <CreateChallan />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/gst-input-output-report"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <GSTInputOutputReports />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/stock-reports"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <StockReports />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/target-tabs"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <TargetTabs />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/edit-customer-target"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <CustomerTargetEditPage />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/profile"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <UserProfile />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/purchase-flow"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <PurchaseTabs />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/device-access"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <DeviceRegistry />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/accounts/create/:id"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <CreateUserAccount />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/sales-person-target/create"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <CreateSalesPersonTarget />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/sales-person-target/edit/:id"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <EditSalesPersonTarget />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/assignment-flow"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <AssignmentFlow />
                // </RequirePerm>
              }
            />
            <Route
              path="/app/gsm-calculator"
              element={
                // <RequirePerm page="Expense Accounts" action="View">
                <GSMCalculator />
                // </RequirePerm>
              }
            />
            {/* Catch-all also protected; unauth → redirects to /login */}
            <Route
              path="*"
              element={
                <RequireAuth>
                  <NotFound />
                </RequireAuth>
              }
            />
          </Routes>
        </main>

        {/* Hide command palette on login page as well */}
        {!isLogin && (
          <CommandPalette
            open={paletteOpen}
            onClose={() => setPaletteOpen(false)}
            menus={navMenus}
            addQuickItem={(v) =>
              setQuickItems((prev) => (prev.includes(v) ? prev : [...prev, v]))
            }
          />
        )}
      </div>
    </ThemeProvider>
  );
}
//basic salary, less advance, less emi, late hours, less deduction, less debit note, add expense reimbursement, add credit note, add adjustment, final pament, nrt to pay
